"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useFileUploadAction = require("./useFileUploadAction");
Object.keys(_useFileUploadAction).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useFileUploadAction[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useFileUploadAction[key];
    }
  });
});